export const finalConfig = {
  esEndpoint: "/es"
}
